export default "__VITE_ASSET__DGI3Jeu4__"